module.exports = __webpack_public_path__ + "img/18_26.744bff8d.png";